import { Routes, Route } from 'react-router-dom';
import { OverviewPage } from './pages/OverviewPage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { RecipesPage } from './pages/RecipesPage';
import { WorkerPage } from './pages/WorkerPage';
import { ProxiesPage } from './pages/ProxiesPage';
import { LinksPage } from './pages/LinksPage';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './components/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="recipes" element={<RecipesPage />} />
        <Route path="worker" element={<WorkerPage />} />
        <Route path="proxies" element={<ProxiesPage />} />
        <Route path="links" element={<LinksPage />} />
      </Route>
    </Routes>
  );
}

export default App;
